import { createAction } from 'redux-actions';

import { ADVENTURES_GET, ADVENTURE_DELETE } from './types';

export const getAdventures = createAction(ADVENTURES_GET);

export const deleteAdventure = createAction(ADVENTURE_DELETE);
